import Vue from 'vue';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import BlockUI from 'vue-blockui';
import HighchartsVue from 'highcharts-vue';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import VueRangeDatePicker from 'vue-rangedate-picker'
import VueMonthlyPicker from 'vue-monthly-picker'
import DateRangePicker from 'vue2-daterange-picker'
// import clevertap from 'clevertap-web-sdk'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-slider-component/theme/default.css'
import '@/assets/stylesheets/main.css';
// set language to EN
// import lang from 'element-ui/lib/locale/lang/en';
// import locale from 'element-ui/lib/locale';

// import DataTables and DataTablesServer together
import VueDataTables from 'vue-data-tables';

// eslint-disable-next-line no-unused-vars
import Vuelidate from 'vuelidate';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTasks,
  faUser,
  faEnvelope,
  faSpinner,
  faMusic,
  faChartLine,
  faWallet,
  faUsers,
  faDrum,
  faAngleRight,
  faTimes,
  faTrashAlt,
  faSync,
  faFileContract,
  faTimesCircle,
  faArrowDown,
  faArrowUp,
  faArrowLeft,
  faEye,
  faEyeSlash,
  faPencilAlt,
  faFileAlt,
  faCheck,
  faBan,
  faCircle,
  faCircleNotch,
  faChartBar, faMoneyBill, faEnvelopeSquare,faAddressBook,
  faChevronDown,faChevronLeft,faChevronCircleLeft,faCheckCircle,faCopy,faBars,faCaretUp, faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import App from './App';
import router from './router';

import store from './stores';
import vClickOutside from 'v-click-outside'

import { StripePlugin } from '@vue-stripe/vue-stripe';

import firebase from 'firebase/compat/app'
const options = {
  pk: process.env.STRIPE_PUBLISH_KEY,
};

Vue.use(StripePlugin, options);
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueDataTables);
Vue.use(BlockUI)
Vue.use(VueSweetalert2);
Vue.use(HighchartsVue)
Vue.use(VueMonthlyPicker)
Vue.use(DateRangePicker)
Vue.use(vClickOutside)
Vue.use(VueCustomTooltip, {
  name: 'VueCustomTooltip',
  color: '#fff',
  background: '#000',
  borderRadius: 12,
  fontWeight: 400,
  zIndex: 10000,
})


// eslint-disable-next-line max-len
library.add(
  faTasks,
  faUser,
  faEnvelope,
  faSpinner,
  faMusic,
  faChartLine,
  faWallet,
  faUsers,
  faDrum,
  faAngleRight,
  faTimes,
  faTrashAlt,
  faSync,
  faFileContract,
  faTimesCircle,
  faArrowDown,
  faArrowUp,
  faArrowLeft,
  faEye,
  faEyeSlash,
  faPencilAlt,
  faFileAlt,
  faCheck,
  faBan,
  faCircleNotch,
  faChartBar,
  faMoneyBill,
  faEnvelopeSquare,
  faAddressBook,
  faChevronDown,
  faChevronCircleLeft,
  faChevronLeft,
  faChevronRight,
  faCheckCircle,
  faCopy,
  faBars,
  faCaretUp
);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;
Vue.mixin({
  methods: {
    toDollar: function (credit = 0) {
      return parseFloat(credit * 0.1);
    },
    toCredit: function (dollar = 0) {
      return parseFloat(dollar * 10);
    }
  }
})
const FIREBASE_CONFIG  = {
  apiKey: "AIzaSyA0K2efbnREXMvvG8WqGcz_1qxZBCvlN1w",
  authDomain: "music-verse.firebaseapp.com",
  projectId: "music-verse",
  storageBucket: "music-verse.appspot.com",
  messagingSenderId: "520003573146",
  appId: "1:520003573146:web:0d3c6b48eff9f567c95623"
}
firebase.initializeApp(FIREBASE_CONFIG);
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js